import Link from "next/link";
// import Image from "next/image";
import Button from "@/Components/Button";

interface BannerData {
  title: string;
  desc: string;
  button: any;
  short_title: string;
}
interface BannerProps {
  data: BannerData;
}

const Banner: React.FC<BannerProps> = ({ data }) => {
  return (
    <section className="relative bg-background-dark text-white pt-32 pb-20 overflow-hidden">
      {/* Background Decorations */}
      {/* <Image
        src="/images/consulting/banner-top.png"
        width={500}
        height={500}
        alt="banner-top"
        className="absolute top-[-80px] left-0"
      />
      <Image
        src="/images/consulting/banner-bottom.png"
        width={400}
        height={400}
        alt="banner-bottom"
        className="absolute bottom-0 right-0"
      /> */}

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <h1 className="text-display font-extrabold mx-auto text-center text-primary-text-white uppercase max-w-[1230px] mb-[32px] md:min-h-[146px]">
          {data.title}
        </h1>

        {/* Description */}
        <p className="text-secondary-text-white text-subtitle-2  mb-2 max-w-[870px] mx-auto">
          {data.short_title}
        </p>

        <Link
          href={data?.button?.[0]?.href ?? "/"}
          className="mx-auto"
          target="_blank"
        >
          <Button
            label={"Get a Free Consultation"}
            className="lg:mt-10 mt-8 mx-auto"
            onClick={() => {}}
          />
        </Link>
      </div>
    </section>
  );
};

export default Banner;
